// Regras do checklist de atendimento em loja, lado do front. Espelha
// backend/src/modules/insumos/services/checklistRegras.js — o backend valida de
// novo, isto aqui serve para avisar o tecnico enquanto ele digita.
//
// RETIRADA = USADA + DEVOLVIDA; estoque final = estoque inicial - usada.

export const TIPO_ATENDIMENTO_LABEL = {
  manutencao: 'Manutenção',
  instalacao: 'Instalação',
};

export const STATUS_CHECKLIST = {
  rascunho: { label: 'Rascunho', pill: '' },
  em_separacao: { label: 'Em separação', pill: 'status-pill--pendente' },
  pronto_para_saida: { label: 'Pronto para saída', pill: 'status-pill--aberta' },
  em_atendimento: { label: 'Em atendimento', pill: 'status-pill--em_rota' },
  aguardando_devolucao: { label: 'Aguardando devolução', pill: 'status-pill--parcial' },
  finalizado: { label: 'Finalizado', pill: 'status-pill--ativo' },
  cancelado: { label: 'Cancelado', pill: 'status-pill--cancelada' },
};

export const STATUS_EDITAVEIS = ['rascunho', 'em_separacao', 'pronto_para_saida'];
export const STATUS_RETORNO = ['em_atendimento', 'aguardando_devolucao'];

const cent = (n) => Math.round(Number(n || 0) * 100);

export function fmtQtd(n) {
  if (n === null || n === undefined || n === '') return '—';
  return Number(n).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
}

// '' -> null; '1,5' -> 1.5; invalido/negativo -> NaN
export function lerQtd(valor) {
  if (valor === null || valor === undefined || String(valor).trim() === '') return null;
  const n = Number(String(valor).replace(',', '.'));
  return Number.isFinite(n) && n >= 0 ? n : NaN;
}

export function hojeISO() {
  const d = new Date();
  const pad = (x) => String(x).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Confere um item na volta. Devolve { ok, pendente, mensagem }.
export function conferirQuantidades({ nome, qtd_retirada, qtd_usada, qtd_devolvida }) {
  const usada = lerQtd(qtd_usada);
  const devolvida = lerQtd(qtd_devolvida);
  if (Number.isNaN(usada) || Number.isNaN(devolvida)) {
    return { ok: false, pendente: false, mensagem: `${nome}: informe números maiores ou iguais a zero.` };
  }
  if (usada === null || devolvida === null) {
    return { ok: false, pendente: true, mensagem: `${nome}: informe a quantidade usada e a devolvida.` };
  }
  const retirada = cent(qtd_retirada);
  const informado = cent(usada) + cent(devolvida);
  if (retirada === informado) return { ok: true, pendente: false, mensagem: 'Quantidades conferem.' };
  if (informado > retirada) {
    return {
      ok: false,
      pendente: false,
      mensagem: `${nome}: usada + devolvida (${fmtQtd(informado / 100)}) passa da quantidade retirada (${fmtQtd(retirada / 100)}).`,
    };
  }
  return {
    ok: false,
    pendente: false,
    mensagem: `${nome}: foram retiradas ${fmtQtd(retirada / 100)} unidades, mas foram informadas apenas `
      + `${fmtQtd(informado / 100)} entre utilizadas e devolvidas (divergência de ${fmtQtd((retirada - informado) / 100)}).`,
  };
}

// Itens com retirada acima do estoque. `estoquePorInsumo`: { id: estoque }.
export function faltasDeEstoque(itens, estoquePorInsumo) {
  const pedido = new Map();
  itens.forEach((it) => {
    if (!it.insumo_id) return;
    const q = lerQtd(it.qtd_retirada);
    if (!q) return;
    const atual = pedido.get(it.insumo_id) || { nome: it.nome, solicitado: 0 };
    atual.solicitado += cent(q);
    pedido.set(it.insumo_id, atual);
  });
  const faltas = [];
  pedido.forEach(({ nome, solicitado }, insumoId) => {
    const disponivel = cent(estoquePorInsumo[insumoId]);
    if (solicitado > disponivel) {
      faltas.push({
        insumo_id: insumoId,
        nome,
        disponivel: disponivel / 100,
        solicitado: solicitado / 100,
        deficit: (solicitado - disponivel) / 100,
      });
    }
  });
  return faltas;
}
